<template>
  <div>

    <div class="relative w-full min-h-[90vh] bg-pagebg text-text">
      <div
          class="max-w-full mx-auto pt-8 px-7">
        <Transition name="fade" appear>
          <div>
            <RouterView/>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
